import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconLoopExit(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 3C3.89 3 3 3.9 3 5L3 19C3 20.1 3.9 21 5 21L6 21C6.55 21 7 20.55 7 20C7 19.45 6.55 19 6 19L5 19L5 5L19 5L19 19L18 19C17.45 19 17 19.45 17 20C17 20.55 17.45 21 18 21L19 21C20.1 21 21 20.1 21 19L21 5C21 3.9 20.11 3 19 3L5 3Z"
        fill="currentColor"
      />
      <path
        d="M12.7071 20.7071C12.3166 21.0976 11.6834 21.0976 11.2929 20.7071L8.29289 17.7071C7.90237 17.3166 7.90237 16.6834 8.29289 16.2929C8.68342 15.9024 9.31658 15.9024 9.70711 16.2929L11 17.5858L11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10L13 17.5858L14.2929 16.2929C14.6834 15.9024 15.3166 15.9024 15.7071 16.2929C16.0976 16.6834 16.0976 17.3166 15.7071 17.7071L12.7071 20.7071Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
